import React, { useState } from 'react';
import { Heart, Compass, Users, TrendingUp, Target, Award, MessageCircle, Calendar, CheckCircle, Star, Lightbulb, Shield } from 'lucide-react';

const Mentorship = () => {
  const [activeMentor, setActiveMentor] = useState(0);

  const mentorshipTypes = [
    {
      title: "Academic Mentorship",
      icon: Lightbulb,
      description: "Personalized guidance for academic excellence, exam preparation, and subject mastery",
      features: [
        "One-on-one doubt clearing sessions",
        "Customized study plans and schedules",
        "Regular progress tracking and feedback",
        "Subject-specific expert guidance",
        "Exam strategy and time management",
        "Weak area identification and improvement"
      ],
      ideal: "Students preparing for JEE, NEET, GATE, Board Exams"
    },
    {
      title: "Career Mentorship",
      icon: Compass,
      description: "Strategic career planning, goal setting, and professional development guidance",
      features: [
        "Career path exploration and planning",
        "College and course selection guidance",
        "Industry insights and job market trends",
        "Resume building and interview preparation",
        "Networking strategies and opportunities",
        "Long-term career roadmap creation"
      ],
      ideal: "Students and professionals seeking career guidance"
    },
    {
      title: "Personal Development",
      icon: Heart,
      description: "Holistic growth focusing on personality, leadership, and life skills development",
      features: [
        "Personality development and confidence building",
        "Communication and presentation skills",
        "Leadership and teamwork abilities",
        "Stress management and mental wellness",
        "Goal setting and achievement strategies",
        "Work-life balance guidance"
      ],
      ideal: "Anyone seeking personal growth and self-improvement"
    },
    {
      title: "Research Mentorship",
      icon: Target,
      description: "Guidance for research scholars, publication strategies, and academic career development",
      features: [
        "Research topic selection and refinement",
        "Methodology and experimental design",
        "Paper writing and publication guidance",
        "Conference presentation preparation",
        "Funding and scholarship opportunities",
        "PhD and postdoc guidance"
      ],
      ideal: "PG students, PhD scholars, and aspiring researchers"
    }
  ];

  const mentors = [
    {
      name: "Bandaru Mahesh",
      qualification: "IIT Kharagpur,(IPhD)",
      specialization: "Bandaru Mahesh is a visionary entrepreneur and educator with a proven track record in developing advanced AI-powered solutions for geosciences, energy exploration, space technologies, and sustainability. His pioneering work integrates quantum computing, satellite systems, artificial general intelligence (AGI), large language models (LLMs), machine learning, IoT, embedded systems, civil engineering innovations, and next-generation software systems to solve some of the world's most complex challenges.",
      experience: "7+ Years",
      achievements: "Founder/CEO of Olewin Group of Companies,International Sponsor & Researcher",
      image: "BMH"
    },
    {
      name: "Ganesh Kumar.G",
      qualification: "IMSc- NIT & ISRO Scientist (certified)",
      specialization: "Network & Communications,Remote sensing Satellite Data modeling. Proven track record in developing advanced AI-powered solutions for geosciences, energy explorations ",
      experience: "15+ Years",
      achievements: "Guided 300+ students, Expert in Career Guidance & Mentorship",
      image: "GS"
    },
        {
      name: " Professors/ International Convenors/ Guest Faculties from IIT's",
      qualification: "PhD ",
      specialization: "Computer Science & Technology",
      experience: "14+ Years",
      achievements: "National & International",
      image: "AP"
    },
             {
      name: "Prem Sai .C ",
      qualification: "MS in (IT-MS) - New Calorina - USA",
      specialization: "Business, Project Manager Professional & Data Analyst",
      experience: "8+ Years",
      achievements: "",
      image: "PS.C"
    },
    {
      name: "Debjit Gosh ",
      qualification: "IIT Kharagpur, IPhD",
      specialization: "Advance Applied Quantum level Mathematics & Physics ",
      experience: "4+ Years",
      achievements: "Professional trainer",
      image: "DG"
    },
    {
      name: "Prof. Devi Das.K ",
      qualification: "PhD ",
      specialization: "Computer Science & Technology",
      experience: "14+ Years",
      achievements: "",
      image: "DK"
    },
      {
      name: "Aparna .B ",
      qualification: "PhD Researcher Scientist ",
      specialization: "Nano Science & Technology",
      experience: "4+ Years",
      achievements: "",
      image: "AB"
    },
         {
      name: "Bishal Singh ",
      qualification: "IIT Kharagpur,PhD Researcher Scientist ",
      specialization: "Biological Sciences, Drug & borderImage: Technology",
      experience: "6+ Years",
      achievements: "",
      image: "BS"
    },
         {
      name: "Soumya . GS ",
      qualification: "Tech lead & Product Manager ",
      specialization: "BlockChain Technology",
      experience: "14+ Years",
      achievements: "",
      image: "S Gs"
    },
         {
      name: "Arnab Dey ",
      qualification: "GeoScientist ",
      specialization: "Field & Data Analyst",
      experience: "3+ Years",
      achievements: "",
      image: "AD"
    },
    
  
  ];

  const process = [
    {
      step: "1",
      title: "Initial Assessment",
      description: "Comprehensive evaluation of your current status, goals, strengths, and areas needing improvement"
    },
    {
      step: "2",
      title: "Mentor Matching",
      description: "Carefully pair you with the most suitable mentor based on your goals, personality, and requirements"
    },
    {
      step: "3",
      title: "Goal Setting",
      description: "Work with your mentor to define clear, achievable short-term and long-term objectives"
    },
    {
      step: "4",
      title: "Action Plan",
      description: "Develop a detailed roadmap with milestones, timelines, and strategies to achieve your goals"
    },
    {
      step: "5",
      title: "Regular Sessions",
      description: "Weekly or bi-weekly one-on-one sessions to track progress, address challenges, and adjust plans"
    },
    {
      step: "6",
      title: "Continuous Support",
      description: "Ongoing guidance, motivation, and support throughout your journey with 24/7 accessibility"
    }
  ];

  const benefits = [
    {
      icon: Target,
      title: "Clarity & Direction",
      description: "Gain clear understanding of your goals and the path to achieve them with expert guidance"
    },
    {
      icon: TrendingUp,
      title: "Accelerated Growth",
      description: "Learn from experience and avoid common pitfalls to achieve success faster"
    },
    {
      icon: Shield,
      title: "Accountability",
      description: "Stay committed to your goals with regular check-ins and mentor support"
    },
    {
      icon: Award,
      title: "Proven Strategies",
      description: "Benefit from tried-and-tested methods used by successful individuals"
    },
    {
      icon: MessageCircle,
      title: "Personalized Attention",
      description: "Receive customized advice tailored to your unique situation and needs"
    },
    {
      icon: Star,
      title: "Confidence Boost",
      description: "Build self-confidence through continuous support and encouragement"
    }
  ];

  const testimonials = [
    {
      name: "Aarav Mehta",
      result: "IIT Bombay, AIR 156",
      text: "My mentor helped me overcome self-doubt and develop a winning strategy. The personalized guidance made all the difference in my JEE preparation.",
      rating: 5
    },
    {
      name: "Diya Kapoor",
      result: "AIIMS Delhi, AIR 89",
      text: "Beyond academics, my mentor taught me how to manage stress and stay motivated. The holistic approach helped me excel in NEET and life.",
      rating: 5
    },
    {
      name: "Rohan Singh",
      result: "Google Software Engineer",
      text: "Career mentorship helped me navigate the tech industry, prepare for interviews, and land my dream job. Invaluable experience!",
      rating: 5
    }
  ];

  const stats = [
    { number: "1000+", label: "Students Mentored" },
    { number: "95%", label: "Goal Achievement Rate" },
    { number: "50+", label: "Expert Mentors" },
    { number: "5000+", label: "Mentorship Hours" }
  ];

  return (
    <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', backgroundColor: '#fff' }}>
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
        color: 'white',
        padding: '100px 20px 80px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 30% 50%, rgba(88, 169, 91, 0.15) 0%, transparent 50%)',
          animation: 'pulse 4s ease-in-out infinite'
        }} />
        <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px', alignItems: 'center' }}>
            <div>
              <h1 style={{
                fontSize: 'clamp(2rem, 5vw, 3rem)',
                fontWeight: 'bold',
                marginBottom: '1.5rem',
                animation: 'fadeInUp 0.8s ease-out',
                lineHeight: '1.2'
              }}>
                Mentorship Program
                <span style={{ color: '#58A95B', display: 'block' }}>Your Guide to Success</span>
              </h1>
              <p style={{
                fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                marginBottom: '2rem',
                lineHeight: '1.8',
                animation: 'fadeInUp 1s ease-out'
              }}>
                Connect with experienced mentors from IIT, AIIMS, and leading industries. 
                Get personalized guidance, strategic planning, and continuous support to achieve 
                your academic and career goals.
              </p>
              <button style={{
                backgroundColor: '#58A95B',
                border: 'none',
                padding: '15px 40px',
                fontSize: '1.1rem',
                fontWeight: '600',
                borderRadius: '8px',
                color: 'white',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                animation: 'fadeInUp 1.2s ease-out'
              }}
              onMouseOver={(e) => e.target.style.transform = 'translateY(-3px)'}
              onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}> <a className='text-white' href="#mentors">Find Your Mentor</a>
                
              </button>
            </div>
            <div style={{ textAlign: 'center', animation: 'float 3s ease-in-out infinite' }}>
              <Compass size={200} color="#58A95B" strokeWidth={1.5} />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ padding: '60px 20px', backgroundColor: '#f8f9fa' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '30px',
            textAlign: 'center'
          }}>
            {stats.map((stat, idx) => (
              <div key={idx} style={{ animation: `fadeInUp ${0.5 + idx * 0.2}s ease-out` }}>
                <h2 style={{
                  fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
                  fontWeight: 'bold',
                  color: '#58A95B',
                  margin: '0 0 10px 0'
                }}>
                  {stat.number}
                </h2>
                <p style={{ fontSize: '1.1rem', color: '#666', margin: 0, fontWeight: '500' }}>
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mentorship Types */}
      <section style={{ padding: '80px 20px', backgroundColor: '#ffffff' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{
            textAlign: 'center',
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            fontWeight: 'bold',
            marginBottom: '1rem',
            color: '#000000'
          }}>
            Types of <span style={{ color: '#58A95B' }}>Mentorship</span>
          </h2>
          <p style={{ textAlign: 'center', fontSize: '1.1rem', color: '#666', marginBottom: '3rem' }}>
            Choose the mentorship program that aligns with your goals and aspirations
          </p>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '30px'
          }}>
            {mentorshipTypes.map((type, idx) => {
              const IconComponent = type.icon;
              return (
                <div key={idx} style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '15px',
                  padding: '30px',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  border: '2px solid transparent'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.backgroundColor = 'white';
                  e.currentTarget.style.borderColor = '#58A95B';
                  e.currentTarget.style.boxShadow = '0 15px 40px rgba(88, 169, 91, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.backgroundColor = '#f8f9fa';
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  <IconComponent size={45} color="#58A95B" style={{ marginBottom: '20px' }} />
                  <h4 style={{ fontWeight: 'bold', marginBottom: '15px', color: '#000' }}>{type.title}</h4>
                  <p style={{ color: '#666', marginBottom: '20px', lineHeight: '1.6' }}>{type.description}</p>
                  
                  <div style={{ marginBottom: '20px' }}>
                    {type.features.map((feature, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
                        <CheckCircle size={16} color="#58A95B" style={{ marginRight: '10px', marginTop: '3px', flexShrink: 0 }} />
                        <span style={{ color: '#666', fontSize: '0.9rem' }}>{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  <div style={{
                    padding: '12px',
                    backgroundColor: '#58A95B',
                    borderRadius: '8px',
                    color: 'white',
                    fontSize: '0.85rem',
                    textAlign: 'center',
                    fontWeight: '600'
                  }}>
                    Ideal for: {type.ideal}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Mentorship Process */}
      <section style={{ padding: '80px 20px', backgroundColor: '#f8f9fa' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{
            textAlign: 'center',
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            fontWeight: 'bold',
            marginBottom: '1rem',
            color: '#000000'
          }}>
            How It <span style={{ color: '#58A95B' }}>Works</span>
          </h2>
          <p style={{ textAlign: 'center', fontSize: '1.1rem', color: '#666', marginBottom: '3rem' }}>
            Simple, structured process to connect you with the right mentor
          </p>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '30px'
          }}>
            {process.map((item, idx) => (
              <div key={idx} style={{
                backgroundColor: 'white',
                borderRadius: '15px',
                padding: '30px',
                position: 'relative',
                boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 15px 40px rgba(88, 169, 91, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 20px rgba(0,0,0,0.08)';
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #58A95B 0%, #4a8f4d 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px',
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  color: 'white'
                }}>
                  {item.step}
                </div>
                <h5 style={{ fontWeight: 'bold', marginBottom: '12px', color: '#000' }}>{item.title}</h5>
                <p style={{ color: '#666', lineHeight: '1.6', margin: 0 }}>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section style={{ padding: '80px 20px', backgroundColor: '#ffffff' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{
            textAlign: 'center',
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            fontWeight: 'bold',
            marginBottom: '3rem',
            color: '#000000'
          }}>
            Benefits of <span style={{ color: '#58A95B' }}>Mentorship</span>
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '30px'
          }}>
            {benefits.map((benefit, idx) => {
              const IconComponent = benefit.icon;
              return (
                <div key={idx} style={{
                  textAlign: 'center',
                  padding: '30px 20px',
                  borderRadius: '15px',
                  border: '2px solid #f0f0f0',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#58A95B';
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.backgroundColor = '#f8f9fa';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#f0f0f0';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}>
                  <IconComponent size={45} color="#58A95B" style={{ marginBottom: '20px' }} />
                  <h5 style={{ fontWeight: '600', marginBottom: '10px', color: '#000' }}>{benefit.title}</h5>
                  <p style={{ color: '#666', lineHeight: '1.6', margin: 0 }}>{benefit.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Featured Mentors */}
      <section id='mentors'  style={{ padding: '80px 20px', backgroundColor: '#f8f9fa' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{
            textAlign: 'center',
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            fontWeight: 'bold',
            marginBottom: '1rem',
            color: '#000000'
          }}>
            Meet Our <span style={{ color: '#58A95B' }}>Mentors</span>
          </h2>
          <p style={{ textAlign: 'center', fontSize: '1.1rem', color: '#666', marginBottom: '3rem' }}>
            Learn from the best - accomplished professionals from premier institutions
          </p>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '30px'
          }}>
            {mentors.map((mentor, idx) => (
              <div key={idx} style={{
                backgroundColor: 'white',
                borderRadius: '15px',
                padding: '30px',
                textAlign: 'center',
                boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 15px 40px rgba(88, 169, 91, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 20px rgba(0,0,0,0.08)';
              }}>
                <div style={{
                  width: '100px',
                  height: '100px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #58A95B 0%, #4a8f4d 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '2rem',
                  fontWeight: 'bold',
                  color: 'white'
                }}>
                  {mentor.image}
                </div>
                <h4 style={{ fontWeight: 'bold', marginBottom: '8px', color: '#000' }}>{mentor.name}</h4>
                <p style={{ color: '#58A95B', marginBottom: '12px', fontSize: '0.9rem', fontWeight: '600' }}>
                  {mentor.qualification}
                </p>
                <p style={{ color: '#666', marginBottom: '8px', fontSize: '0.95rem' }}>
                  <strong>Specialization:</strong> {mentor.specialization}
                </p>
                <p style={{ color: '#666', marginBottom: '8px', fontSize: '0.95rem' }}>
                  <strong>Experience:</strong> {mentor.experience}
                </p>
                <p style={{ color: '#666', fontSize: '0.9rem', lineHeight: '1.5' }}>
                  {mentor.achievements}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section style={{ padding: '80px 20px', backgroundColor: '#000000', color: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{
            textAlign: 'center',
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            fontWeight: 'bold',
            marginBottom: '3rem',
            color:'wheat'
          }}>
            Success <span style={{ color: '#58A95B' }}>Stories</span>
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '30px'
          }}>
            {testimonials.map((testimonial, idx) => (
              <div key={idx} style={{
                backgroundColor: '#1a1a1a',
                border: '1px solid #333',
                borderRadius: '15px',
                padding: '30px',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#58A95B';
                e.currentTarget.style.transform = 'translateY(-5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#333';
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                <div style={{ display: 'flex', gap: '5px', marginBottom: '15px', justifyContent: 'center' }}>
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={20} fill="#58A95B" color="#58A95B" />
                  ))}
                </div>
                <p style={{ color: '#ddd', fontStyle: 'italic', marginBottom: '20px', lineHeight: '1.6' }}>
                  "{testimonial.text}"
                </p>
                <h6 style={{ color: 'white', fontWeight: 'bold', marginBottom: '5px' }}>{testimonial.name}</h6>
                <p style={{ color: '#58A95B', margin: 0, fontSize: '0.9rem' }}>{testimonial.result}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: '80px 20px',
        background: 'linear-gradient(135deg, #58A95B 0%, #4a8f4d 100%)',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', fontWeight: 'bold', marginBottom: '1.5rem' }}>
            Ready to Transform Your Journey?
          </h2>
          <p style={{ fontSize: 'clamp(1rem, 2vw, 1.2rem)', marginBottom: '2rem', lineHeight: '1.6' }}>
            Connect with a mentor today and take the first step towards achieving your dreams. 
            Your success story starts here.
          </p>
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button style={{
              backgroundColor: '#000000',
              border: 'none',
              padding: '15px 40px',
              fontSize: '1.1rem',
              fontWeight: '600',
              borderRadius: '8px',
              color: 'white',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#1a1a1a';
              e.target.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#000000';
              e.target.style.transform = 'scale(1)';
            }}>
              Get Started Today
            </button>
            <button style={{
              backgroundColor: 'transparent',
              border: '2px solid white',
              padding: '15px 40px',
              fontSize: '1.1rem',
              fontWeight: '600',
              borderRadius: '8px',
              color: 'white',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = '#58A95B';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = 'white';
            }}>
              Schedule Consultation
            </button>
          </div>
        </div>
      </section>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 0.5;
          }
          50% {
            opacity: 0.8;
          }
        }

        * {
          box-sizing: border-box;
        }

        button {
          font-family: inherit;
        }

        @media (max-width: 768px) {
          section {
            padding: 60px 15px !important;
          }import { initializeApp } from 'firebase/app';

        }
      `}</style>
    </div>
  );
};

export default Mentorship;